const PrivacyPolicy = () => {
    return (
      <main
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          padding: "40px 20px",
          fontFamily: "Arial, sans-serif",
          lineHeight: 1.6,
          color: "#ffffff",
        }}
      >
        <h1>Privacy Policy</h1>
  
        <p>
          <strong>Last Updated:</strong> 5/7/2026
        </p>
  
        <p>
          This Privacy Policy explains how we collect, use, and protect information
          submitted through this website.
        </p>
  
        <h2>Information We Collect</h2>
        <p>
          We may collect personal information that you voluntarily provide,
          including your name, email address, phone number, property information,
          uploaded photos, and any other details submitted through our forms.
        </p>
  
        <h2>How We Use Your Information</h2>
        <p>
          We use the information you provide to respond to your request, evaluate
          your inquiry, contact you, schedule appointments, provide services, and
          manage client communications.
        </p>
  
        <h2>Uploaded Photos and Files</h2>
        <p>
          If you upload photos or files, they may be reviewed by authorized team
          members for the purpose of understanding your request and providing
          appropriate service.
        </p>
  
        <h2>Sharing of Information</h2>
        <p>
          We do not sell your personal information. We may share information with
          service providers, business partners, or authorized representatives when
          necessary to respond to your inquiry, provide services, operate this
          website, or comply with legal obligations.
        </p>
  
        <h2>Data Security</h2>
        <p>
          We use reasonable administrative, technical, and organizational measures
          to protect submitted information. However, no website, transmission, or
          storage system can be guaranteed to be completely secure.
        </p>
  
        <h2>Data Retention</h2>
        <p>
          We may retain submitted information for as long as reasonably necessary
          to respond to inquiries, provide services, maintain business records, or
          comply with legal obligations.
        </p>
  
        <h2>Cookies and Analytics</h2>
        <p>
          This website may use cookies, analytics tools, or similar technologies to
          understand website usage, improve performance, and maintain security.
        </p>
  
        <h2>Your Choices</h2>
        <p>
          You may contact us to request access, correction, or deletion of your
          personal information, subject to applicable legal and business record
          requirements.
        </p>
  
        <h2>Third-Party Links</h2>
        <p>
          This website may contain links to third-party websites. We are not
          responsible for the privacy practices, content, or security of those
          third-party websites.
        </p>
  
        <h2>Children’s Privacy</h2>
        <p>
          This website is not intended for children under the age of 13. We do not
          knowingly collect personal information from children.
        </p>
  
        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be
          posted on this page with an updated effective date.
        </p>
  
        <h2>Contact Us</h2>
        <p>
          For questions about this Privacy Policy or how your information is
          handled, please contact us at:
        </p>
  
        <p>
          <strong>Griffin Managed Web Solutions</strong>
          <br />
          info@griffinmanagedwebsolutions.com
          <br />
          +1 (346) 800-2659
        </p>
      </main>
    );
  };
  
  export default PrivacyPolicy;